// True when a URL is present and uses an http(s) scheme. Mirrors the backend
// admin-feed-update validation (`/^https?:\/\/.+/` in rest-schema.conversion.ts):
// feeds without a real site URL must not be accepted or cataloged.
export const isHttpUrl = (url: string | undefined | null): boolean => !!url && /^https?:\/\/.+/i.test(url);

// True when a URL's host is youtube.com or any subdomain of it (e.g. www.youtube.com).
// YouTube channel feeds are auto-approved during admin review and never categorized.
export const isYoutubeUrl = (url: string | undefined | null): boolean => {
  if (!url) return false;
  try {
    const host = new URL(url).hostname.toLowerCase();
    return host == 'youtube.com' || host.endsWith('.youtube.com');
  } catch {
    return false;
  }
};

/** Whether the search input is a URL / domain to add, rather than search terms for the catalog. */
export const isUrlLike = (input: string): boolean => {
  const trimmed = input.trim();

  // Case 1: Full URL with protocol and domain
  // Must have protocol followed by // and at least a domain with TLD
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://'))
    // Check if there's at least a valid domain (word.word pattern) after the protocol
    return /^[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+/.test(trimmed.substring(trimmed.indexOf('//') + 2));

  // Case 2 & 3: 2 or 3 part domains
  // Match: example.org, nyt.com, news.ycombinator.com, etc.
  return /^[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)?$/.test(trimmed);
};
